import React, { useEffect, useState } from "react";
import QRCode from "qrcode";
import App from "../../App";
import { ToastContainer, toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import downloadButtonIcon from "../../assets/photos/qrdownload.png";
import { connect } from "react-redux";

//Qrcode for admin side

const AdminQrcode = (props) => {
  const [imgUrl, setImageUrl] = useState("");
  const [loading, setloading] = useState(false);
  const [correctionLevel, setCorrectionLevel] = useState("H");

  useEffect(() => {
    generateQrCode();
  }, []);

  const toastMessagePopUp = (message) => {
    // toast error message popup function
    toast.error(message, {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
  };

  const generateQrCode = async () => {
    // generates qr code from the response
    try {
      setloading(true);
      const uuid = props.museum.uuid;
      // console.log(App.baseURl + "login/" + uuid);
      let opts = {
        errorCorrectionLevel: correctionLevel,
        type: 'image/png',
        quality: 1,
        margin: 3,
        color: {
          dark: "#000000",
          light: "#FFFFFF"
        }
      }
      let response = "";
      await QRCode.toDataURL(App.frontendBaseUrl + "login/" + uuid, opts, (err, url) => {
        if (err) {
          throw err;
        }
        response = url;
        switchQrCorrectionLevel();
      });
      console.log(response);
      setImageUrl(response);
      setTimeout(() => {
        setloading(false);
      }, 100);
    } catch (error) {
      toastMessagePopUp("something went wrong");
    }
  };

  const switchQrCorrectionLevel = () => {
    switch (correctionLevel) {
      case 'H':
        setCorrectionLevel('L');
        break;
      case 'L':
        setCorrectionLevel('M');
        break;
      case 'M':
        setCorrectionLevel('Q');
        break;
      case 'Q':
        setCorrectionLevel('H');
        break;
    }
  }

  const downloadImage = async () => {
    // downloads the qrcode
    try {
      const url = imgUrl;
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "image.png");
      document.body.appendChild(link);
      link.click();
    } catch (error) {
      toastMessagePopUp("something went wrong");
    }
  };

  if (imgUrl === "") {
    // if there is no qrcode then show spinner loader
    return <Spinner animation="border" />;
  } else {
    // else show the component
    return (
      <div className="qrcode-content">
        <div className="qrcode-text">
          Download QR Code for
          <br />
          {props.museum ? props.museum.name : ""}
        </div>
        <div className="qrcode-code">
          <div className="qrcode-code-background" />
          <div className="qrcode-code-qr">
            <img
              className={loading ? "qr-code-image" : ""}
              src={imgUrl}
              height="282px"
              width="282px"
              loading="lazy"
            />
          </div>
        </div>
        <div id="qr-button-area">
          <button
            id="qr-dowload-button-2"
            className="qrcode-download-button"
            onClick={generateQrCode}
          >
            {/* Generate QR<img id="qr-download-icon" src="" width="19px" height="19px" /> */}
            Generate QR
          </button>
          <button
            id="qr-dowload-button"
            className="qrcode-download-button"
            onClick={downloadImage}
          >
            {/* Download QR<img id="qr-download-icon" src="" width="19px" height="19px" /> */}
            Download QR{" "}
            <img
              src={downloadButtonIcon}
              id="qr-download-icon"
              width="19px"
              height="19px"
            />
          </button>
        </div>
        <ToastContainer
          limit={1}
          position="bottom-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    museum: state.museumData.museumData,
  };
};

export default connect(mapStateToProps, null)(AdminQrcode);
